import React, { useState, useEffect } from 'react';
import './popupbox.css';
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from 'react-router-dom';
import { SEND_API } from '../../utils/APIs';
import { RECAPTCHA_SITEKEY } from '../../utils/config';

function Popupboxbox({ isOpen, onClose }) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    subject: "Course Enquiry",
    message: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [responseMsg, setResponseMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please complete the CAPTCHA");
      return;
    }

    setIsLoading(true);

    const formDataObj = new FormData();
    formDataObj.append("name", formData.name);
    formDataObj.append("email", formData.email);
    formDataObj.append("phone", formData.phone);
    formDataObj.append("course", formData.course);
    formDataObj.append("subject", formData.subject);
    formDataObj.append("message", formData.message);

    // For backend validation
    formDataObj.append("g-recaptcha-response", captchaValue);

    try {
      const response = await fetch(`${SEND_API}`, {
        method: "POST",
        body: formDataObj,
      });

      const result = await response.text();
      console.log("Server Response:", result);

      // Check for ANY type of success message
      if (result.toLowerCase().includes("success")) {
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          course: "",
          subject: "Course Enquiry",
          message: "",
        });

        setCaptchaValue(null);

        onClose(); // Close popup

        // Redirect
        navigate("/thankyou");
      } else {
        setResponseMsg(result);
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };


  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-container">

        <button onClick={onClose} className="close-btnn" aria-label="Close modal">
          &times;
        </button>

        <h2>Fill now and get flat 5000 – 10000 Rs off on course fee.</h2>

        <form className="modal-form" onSubmit={handleSubmit}>

          <div className="form-row">
            <div className="form-group">
              <label>Name</label>
              <input type="text" name="name" placeholder="Enter your Name" onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" placeholder="Enter your Email" onChange={handleChange} required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Phone Number</label>
              <input type="tel" name="phone" placeholder="Phone Number"
                maxLength={10} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Course interested in</label>
              <select name="course" onChange={handleChange} defaultValue="" required>
                <option value="" disabled hidden>Course interested in *</option>
                <option value="AI & Machine Learning">AI & Machine Learning</option>
                <option value="Python Development">Python Development</option>
                <option value="Java Full Stack">Java Full Stack</option>
                <option value=".Net Framework">.Net Framework</option>
                <option value="Java">Java</option>
                <option value=".NET">.NET</option>
                <option value="Python">Python</option>
                <option value="C, C++">C, C++</option>
                <option value="PHP">PHP</option>
                <option value="Open stack">Open stack</option>
                <option value="Kubernetes">Kubernetes</option>
                <option value="DevOps">DevOps</option>
                <option value="Data Science">Data Science</option>
                <option value="Deep Learning">Deep Learning</option>
                <option value="Machine Learning">Machine Learning</option>
                <option value="AI - Artificial Intelligence">AI – Artificial Intelligence</option>
                <option value="AWS">AWS</option>
                <option value="AZURE">AZURE</option>
                <option value="SALESFORCE">SALESFORCE (Developer / Administrator)</option>
                <option value="Manual Testing">Manual Testing</option>
                <option value="Selenium">Selenium</option>
                <option value="JMeter">JMeter</option>
                <option value="ETL Testing">ETL Testing</option>
                <option value="Big Data Testing">Big Data Testing</option>
                <option value="Load Runner testing">Load Runner testing</option>
                <option value="CSS">CSS</option>
                <option value="HTML">HTML</option>
                <option value="Angular JS">Angular JS</option>
                <option value="Nodejs">Nodejs</option>
                <option value="UI/UX">UI/UX</option>
                <option value="MYSQL">MYSQL</option>
                <option value="MONGODB">MONGODB</option>
                <option value="SQL SERVER DBA">SQL SERVER DBA</option>
                <option value="CCNA">CCNA</option>
                <option value="CCNP">CCNP</option>
                <option value="A+N+">A+N+</option>
                <option value="LINUX">LINUX</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea className="text-area" name="message" placeholder="Enter your Message" rows="3" onChange={handleChange}></textarea>
          </div>

          <div className="captcha-container">
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITEKEY}
              onChange={(value) => setCaptchaValue(value)}
              className="captcha-box1"
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="download-btn"

              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send Message"}</button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default Popupboxbox;